import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

type PropTypes = {
  tip: string;
};

const Tips = ({ tip }: PropTypes) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        mt: theme.spacing(2),
        p: theme.spacing(1, 3),
        borderLeftWidth: theme.spacing(0.4),
        borderLeftStyle: 'solid',
        borderLeftColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.dark,
      }}
    >
      <Typography variant="body1">
        <strong>{t('Tip')}: </strong>
        {tip}
      </Typography>
    </Box>
  );
};

export default Tips;
